var __rspack_ns_object = JSON.parse('{"Series is tracked":"Serie wird verfolgt","Series is untracked":"Serie wird nicht verfolgt","Viewport":"Viewport"}')